import React from 'react';

import { Tag } from 'lucide-react';

import styles from 'css-module/components/www/_PricingV4.module.scss';

import type { Timeframe } from './Timeframe';

type Props = {
  timeframe: Timeframe;
  setTimeframe: (timeframe: Timeframe) => void;
};
export default function PricingV4TimeframeToggle({ timeframe, setTimeframe }: Props) {
  return (
    <div className={styles.pricingV4TimeframeToggle}>
      <button
        className={styles.timeframeToggleButton}
        data-selected={timeframe === 'yearly'}
        onClick={() => setTimeframe('yearly')}>
        Yearly
        <Tag size={14} />
        20% off
      </button>
      <button
        className={styles.timeframeToggleButton}
        data-selected={timeframe === 'monthly'}
        onClick={() => setTimeframe('monthly')}>
        Monthly
      </button>
    </div>
  );
}
